import useMount from '@src/utils/hooks/use-mount';
import BaseStore from '@src/utils/store/base-store';
import { aLink } from '@src/utils/common-util';
import { observable } from 'mobx';
import { useEffect } from 'react';
import AntdMessage from '@src/components/antd/message';
import $$tracker from '@src/tracker';
class ReviewSectionStore extends BaseStore {
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }
  @observable mainStore;

  @observable isActive = false;
  // H5游戏状态

  @observable h5GameStatus = 0;

  //按钮是否禁用
  @observable disabledBtn = false;

  //活动链接
  @observable activityLink = '';

  clickReview() {
    // if (this.mainStore.drawSectionStore.activityStatus === 0) {
    //   AntdMessage.error('活动未开始');
    //   return;
    // }
    switch (this.h5GameStatus) {
      case 0:
        AntdMessage.error('活动未开始');
        break;
      case 2:
      case 4:
        AntdMessage.error('敬请期待');
        break;
      case 6:
        AntdMessage.error('活动已结束');
        break;
      case 1:
      case 3:
      case 5:
        aLink(this.activityLink);
        $$tracker.clickGoH5game();
        if (this.mainStore.loginState) {
          this.mainStore.onExecuteMission('focusReview');
        }
        break;
      default:
        break;
    }
  }

  use() {
    super.use();
    useMount(() => {
      this.activityLink =
        DEPLOY_ENV === 'master' ? 'https://www.cbjq.com/lovevowswithyou/index.html' : 'https://test-zt.xoyo.com/www.cbjq.com/p/m/2026/01/23/activity/#/';

      if (this.h5GameStatus === 2 || this.h5GameStatus === 4) {
        this.disabledBtn = true;
      }
    });
    useEffect(
      () => {
        this.isActive = this.mainStore.pageSwiperIndex === 2;
      },
      [this.mainStore.pageSwiperIndex]
    );
  }
}

export default ReviewSectionStore;
